import React from "react";

const Card = ({ children }) => {
  return (
    <div className="border p-4 rounded-lg shadow bg-white">
      {children}
    </div>
  );
};

export default Card;
